'use client';

import { getClasses } from '@/_utils/classnames';
import styles from './CardTable.module.css';
import { type FC, useRef } from 'react';
import { useDetectColumnOverflow } from '@/_hooks/useDetectColumnOverflow';
import { TableLoading } from '@/_components';
import type { CardTableProps } from './CardTable.types';

export const CardTable: FC<CardTableProps> = ({
  children,
  hasSelection,
  isInline,
  isLoading,
  'data-testid': dataTestId,
}) => {
  const tableRef = useRef<HTMLTableElement | null>(null);
  const { isOverflowing, isAtEnd } = useDetectColumnOverflow(
    tableRef,
    isLoading,
  );

  const cardTableClasses: string = getClasses(styles.cardTable, {
    [styles.cardTableWithSelection]: hasSelection,
    [styles.cardTableInline]: isInline,
    [styles.cardTableOverflowing]: isOverflowing && !isAtEnd,
  });

  return (
    <div ref={tableRef} className={cardTableClasses} data-testid={dataTestId}>
      {isLoading ? <TableLoading /> : children}
    </div>
  );
};
